import { SOFTWARE_PAGE_VIEWED_COOKIE, AVT_COOKIE } from 'constants/cookies';
import Cookies from 'js-cookie';

export const getSoftwarePageViewed = () => {
  const cookieValue = Cookies.get(SOFTWARE_PAGE_VIEWED_COOKIE);
  return cookieValue === 'true';
};

export const getAvt = () => {
  return Cookies.get(AVT_COOKIE) || null;
};
